import { MatDialog } from '@angular/material/dialog';
import { LegalPersonFormComponent } from './../../generics/forms/legal-person-form/legal-person-form.component';
import { Address } from './../../../models/address.model';
import { SelectOptionsService } from './../../../services/select-options.service';
import { Locality } from './../../../models/locality.model';
import { OwnersService } from './../../../services/owners.service';
import { getOwnerName, Owner } from './../../../models/owner.model';
import { PersonType } from '../../../models/person-type.model';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray, AbstractControl } from '@angular/forms';
import { ErrorResponse } from './../../../models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { CSVColumnMap } from '../../generics/bulk-creator/bulk-creator.component';
import { generatePhysicalPersonFG } from 'src/app/models/physical-person.model';
import { generateLegalPersonFG } from 'src/app/models/legal-person.model';
import * as moment from 'moment';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { Broker } from 'src/app/models/broker.model';
import { BrokerSelectorDialogComponent } from 'src/app/dialogs/broker-selector-dialog/broker-selector-dialog.component';
import { BrokersService } from 'src/app/services/brokers.service';

@Component({
    selector: 'app-edit-owner',
    templateUrl: './edit-owner.component.html',
    styleUrls: ['./edit-owner.component.scss']
})
export class EditOwnerComponent implements OnInit {

    getOwnerName = getOwnerName;

    owner: Owner;
    user: User;
    broker: Broker;

    ownerFG = new UntypedFormGroup({
        codigo: new UntypedFormControl('', [Validators.required]),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        tipoPersona: new UntypedFormControl('FISICA', [Validators.required]),
        personaFisica: generatePhysicalPersonFG('OWNER'),
        personaJuridica: generateLegalPersonFG()
    });

    get physicalPersonFG() {
        return this.ownerFG.controls.personaFisica as UntypedFormGroup;
    }

    get legalPersonFG() {
        return this.ownerFG.controls.personaJuridica as UntypedFormGroup;
    }

    get personFG() {
        return this.personType === 'FISICA' ? this.physicalPersonFG : this.legalPersonFG;
    }

    get representativeFG() {
        return this.personFG.controls.representante as UntypedFormGroup;
    }

    get addressFG() {
        return this.personFG.controls.direccion as UntypedFormGroup;
    }

    @ViewChild('stepper', { static: true })
    stepper: MatStepper;

    @ViewChild(LegalPersonFormComponent, { static: false })
    legalPersonForm: LegalPersonFormComponent;

    bulkCreatorColumnMaps: CSVColumnMap[] = [
        { key: 'tipoPersona', description: 'Tipo de persona' },
        { key: 'codigo', description: 'Código' },
        { key: 'nombre', description: 'Nombre (persona física)' },
        { key: 'apellido', description: 'Apellido (persona física)' },
        { key: 'razonSocial', description: 'Razón social (persona jurídica)' },
        { key: 'dni', description: 'DNI (persona física)' },
        { key: 'sexo', description: 'Sexo (persona física)' },
        { key: 'fechaNacimiento', description: 'Fecha de nacimiento (persona física)' },
        { key: 'cuit', description: 'CUIT (persona jurídica)' },
        { key: 'celular', description: 'Teléfono' },
        { key: 'email', description: 'Email' },
        { key: 'rubro', description: 'Rubro (persona jurídica)' },
        { key: 'situacionIVA', description: 'Situacion frente al IVA (persona jurídica)' },
        { key: 'tipoSociedad', description: 'Tipo de sociedad (persona jurídica)' },
        { key: 'tipoCalle', description: 'Tipo de calle' },
        { key: 'calle', description: 'Calle' },
        { key: 'numero', description: 'Número' },
        { key: 'piso', description: 'Piso' },
        { key: 'departamento', description: 'Departamento' },
        { key: 'codigoPostal', description: 'Código postal' },
        { key: 'provincia', description: 'Provincia' },
        { key: 'municipio', description: 'Municipio' },
        { key: 'localidad', description: 'Localidad' },
    ];

    validatorFormGroupPersonaFisica = new UntypedFormGroup({
        codigo: new UntypedFormControl('', [Validators.required]),
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        dni: new UntypedFormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8), this.utilsService.numberFormValidator]),
        sexo: new UntypedFormControl('', [Validators.required]),
        fechaNacimiento: new UntypedFormControl('', [Validators.required, (control: UntypedFormControl) => moment(control.value, 'DD/MM/YYYY').isValid() ? undefined : { dateFormat: false }]),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        tipoCalle: new UntypedFormControl('', [Validators.required]),
        calle: new UntypedFormControl('', [Validators.required]),
        numero: new UntypedFormControl('', [Validators.required]),
        piso: new UntypedFormControl('', []),
        departamento: new UntypedFormControl('', []),
        codigoPostal: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', []),
        municipio: new UntypedFormControl('', []),
        localidad: new UntypedFormControl('', []),
        tipoPersona: new UntypedFormControl('', [Validators.required]),
        razonSocial: new UntypedFormControl('', []),
        cuit: new UntypedFormControl('', []),
        rubro: new UntypedFormControl('', []),
        situacionIVA: new UntypedFormControl('', []),
        tipoSociedad: new UntypedFormControl('', []),
    });

    validatorFormGroupPersonaJuridica = new UntypedFormGroup({
        codigo: new UntypedFormControl('', [Validators.required]),
        nombre: new UntypedFormControl('', []),
        apellido: new UntypedFormControl('', []),
        celular: new UntypedFormControl('', [Validators.required]),
        dni: new UntypedFormControl('', []),
        sexo: new UntypedFormControl('', []),
        fechaNacimiento: new UntypedFormControl('', []),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        tipoCalle: new UntypedFormControl('', [Validators.required]),
        calle: new UntypedFormControl('', [Validators.required]),
        numero: new UntypedFormControl('', [Validators.required]),
        piso: new UntypedFormControl('', []),
        departamento: new UntypedFormControl('', []),
        codigoPostal: new UntypedFormControl('', [Validators.required]),
        provincia: new UntypedFormControl('', []),
        municipio: new UntypedFormControl('', []),
        localidad: new UntypedFormControl('', []),
        tipoPersona: new UntypedFormControl('', [Validators.required]),
        razonSocial: new UntypedFormControl('', [Validators.required]),
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator]),
        rubro: new UntypedFormControl('', [Validators.required]),
        situacionIVA: new UntypedFormControl('', [Validators.required]),
        tipoSociedad: new UntypedFormControl('', [Validators.required]),
    });

    get personType() {
        return this.ownerFG.controls.tipoPersona.value as PersonType;
    }

    get showBrokerSelectionStep() {
        return this.user?.tipo === 'CORPORATIVO' || this.user.tipo === 'OFICINA';
    }

    constructor(
        private route: ActivatedRoute,
        private ownersService: OwnersService,
        public utilsService: UtilsService,
        private router: Router,
        private authService: AuthService,
        private selectOptionsService: SelectOptionsService,
        private dialog: MatDialog,
        private brokersService: BrokersService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.user = this.authService.getUser();
        if (this.user.tipo === 'AGENTE' && this.user.agente) {
            this.broker = this.user.agente;
        }
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.ownersService.getOwnerById(params.id).subscribe(owner => {
                    this.owner = owner;
                    this.fillFormsWithOwnerData();
                    if (this.owner.idAgente) {
                        this.brokersService.getBrokerById(this.owner.idAgente).subscribe(broker => this.broker = broker);
                    }
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos del propietario', error.error?.descripcion));
            }
        });
        this.ownerFG.controls.codigo.valueChanges.subscribe(newValue => {
            this.checkCodigoAvailability(newValue);
        });

    }

    checkCodigoAvailability(codigo: string) {
        if (codigo !== this.owner?.codigo) {
            this.ownersService.isAvailable('codigo', codigo).subscribe(response => {
                let errors: any;
                if (!response.disponible)
                    errors = { notAvailable: true };
                this.ownerFG.controls.codigo.setErrors(errors);
            }, () => {}); // Ignoramos el error
        }
    }
    fillFormsWithOwnerData() {
        setTimeout(() => {
            this.utilsService.fillFormWithPartialData(this.ownerFG, this.owner);
            const tieneRepresentante = this.owner.tipoPersona === 'FISICA' ? !!this.owner.personaFisica.representante : !!this.owner.personaJuridica.representante;
            this.representativeFG.controls.tieneRepresentante.setValue(tieneRepresentante, { emitEvent: false });
            this.ownerFG.controls.tipoPersona.disable();

            // Cargar DNI y pasaporte si existen, y establecer el tipo según cuál tenga valor
            if (this.owner.tipoPersona === 'FISICA') {
                this.physicalPersonFG.controls.sexo.disable();
                // Cargar ambos campos si existen
                if (this.owner.personaFisica.dni) {
                    this.physicalPersonFG.controls.dni?.setValue(this.owner.personaFisica.dni, { emitEvent: false });
                }
                if (this.owner.personaFisica.pasaporte) {
                    this.physicalPersonFG.controls.pasaporte?.setValue(this.owner.personaFisica.pasaporte, { emitEvent: false });
                }

                // Establecer el tipo de documento según prioridad: DNI primero, luego pasaporte
                if (this.owner.personaFisica.dni) {
                    this.physicalPersonFG.controls.tipoDocumento?.setValue('DNI', { emitEvent: false });
                } else if (this.owner.personaFisica.pasaporte) {
                    this.physicalPersonFG.controls.tipoDocumento?.setValue('PASAPORTE', { emitEvent: false });
                }
            }

            // Marcar el formulario como pristine después de cargar los datos
            this.ownerFG.markAsPristine();
            this.ownerFG.markAsUntouched();
        }, 0);
    }


    isValid(control: AbstractControl) {
        if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
            return Object.keys(control.controls).every(key => this.isValid(control.controls[key]));
        } else if (control instanceof UntypedFormControl) {
            return control.status === 'VALID' || control.status === 'DISABLED';
        } else {
            return false;
        }
    }

    isGeneralSectionValid() {
        let valid = true;
        if (!this.isValid(this.ownerFG.controls.email) || !this.isValid(this.ownerFG.controls.codigo)) {
            valid = false;
        }
        if (this.ownerFG.controls.tipoPersona.value === 'FISICA') {
            // Validamos persona física
            if (
                !this.isValid(this.physicalPersonFG.controls.dni) ||
                !this.isValid(this.physicalPersonFG.controls.sexo) ||
                !this.isValid(this.physicalPersonFG.controls.nombre) ||
                !this.isValid(this.physicalPersonFG.controls.apellido) ||
                !this.isValid(this.physicalPersonFG.controls.celular) ||
                !this.isValid(this.physicalPersonFG.controls.fechaNacimiento)
            ) {
                valid = false;
            }
        } else {
            // Validamos persona jurídica
            if (
                !this.isValid(this.legalPersonFG.controls.cuit) ||
                !this.isValid(this.legalPersonFG.controls.razonSocial) ||
                !this.isValid(this.legalPersonFG.controls.tipoSociedad) ||
                !this.isValid(this.legalPersonFG.controls.rubro) ||
                !this.isValid(this.legalPersonFG.controls.situacionIVA) ||
                !this.isValid(this.legalPersonFG.controls.celular)
            ) {
                valid = false;
            }
        }
        return valid;
    }

    isRepresentativeSectionValid() {
        if (this.representativeFG.controls.tieneRepresentante.value) {
            return this.isValid(this.representativeFG);
        } else {
            return true;
        }
    }

    isAddressSectionValid() {
        return this.isValid(this.addressFG);
    }

    getResultingOwner() {
        const value = this.ownerFG.getRawValue();
        const owner: Owner = {
            id: this.owner?.id,
            idOficina: this.broker?.oficina?.id,
            idAgente: this.broker?.id,
            codigo: value.codigo,
            email: value.email,
            tipoPersona: value.tipoPersona,
            personaFisica: value.tipoPersona === 'FISICA' ? {
                dni: value.personaFisica.tipoDocumento === 'DNI' ? value.personaFisica.dni : null,
                pasaporte: value.personaFisica.tipoDocumento === 'PASAPORTE' ? value.personaFisica.pasaporte : null,
                sexo: value.personaFisica.sexo,
                nombre: value.personaFisica.nombre,
                apellido: value.personaFisica.apellido,
                celular: value.personaFisica.celular,
                fechaNacimiento: value.personaFisica.fechaNacimiento,
                direccion: {
                    tipoCalle: value.personaFisica.direccion.tipoCalle,
                    calle: value.personaFisica.direccion.calle,
                    numero: value.personaFisica.direccion.numero,
                    piso: value.personaFisica.direccion.piso,
                    departamento: value.personaFisica.direccion.departamento,
                    codigoPostal: value.personaFisica.direccion.codigoPostal,
                    localidad: value.personaFisica.direccion.localidad,
                },
                representante: value.personaFisica.representante.tieneRepresentante ? {
                    nombre: value.personaFisica.representante.nombre,
                    apellido: value.personaFisica.representante.apellido,
                    fechaNacimiento: value.personaFisica.representante.fechaNacimiento,
                    cargo: value.personaFisica.representante.cargo,
                    fechaPoder: value.personaFisica.representante.fechaPoder,
                    poderAdjunto: value.personaFisica.representante.poderAdjunto,
                    nombreCargo: value.personaFisica.representante.nombreCargo,
                    nroAsambleaEstatuto: value.personaFisica.representante.nroAsambleaEstatuto,
                    mail: value.personaFisica.representante.mail,
                    celular: value.personaFisica.representante.celular,
                    dni: value.personaFisica.representante.dni,
                    direccion: {
                        tipoCalle: value.personaFisica.representante.direccion.tipoCalle,
                        calle: value.personaFisica.representante.direccion.calle,
                        numero: value.personaFisica.representante.direccion.numero,
                        piso: value.personaFisica.representante.direccion.piso,
                        departamento: value.personaFisica.representante.direccion.departamento,
                        codigoPostal: value.personaFisica.representante.direccion.codigoPostal,
                        localidad: value.personaFisica.representante.direccion.localidad,
                    },
                } : null,
            } : null,
            personaJuridica: value.tipoPersona === 'JURIDICA' ? {
                cuit: value.personaJuridica.cuit,
                razonSocial: value.personaJuridica.razonSocial,
                tipoSociedad: value.personaJuridica.tipoSociedad,
                rubro: value.personaJuridica.rubro,
                tipoSociedadPersonalizado: value.personaJuridica.tipoSociedadPersonalizado,
                rubroPersonalizado: value.personaJuridica.rubroPersonalizado,
                situacionIVA: value.personaJuridica.situacionIVA,
                celular: value.personaJuridica.celular,
                direccion: {
                    tipoCalle: value.personaJuridica.direccion.tipoCalle,
                    calle: value.personaJuridica.direccion.calle,
                    numero: value.personaJuridica.direccion.numero,
                    piso: value.personaJuridica.direccion.piso,
                    departamento: value.personaJuridica.direccion.departamento,
                    codigoPostal: value.personaJuridica.direccion.codigoPostal,
                    localidad: value.personaJuridica.direccion.localidad,
                },
                representante: value.personaJuridica.representante.tieneRepresentante ? {
                    nombre: value.personaJuridica.representante.nombre,
                    apellido: value.personaJuridica.representante.apellido,
                    fechaNacimiento: value.personaJuridica.representante.fechaNacimiento,
                    cargo: value.personaJuridica.representante.cargo,
                    fechaPoder: value.personaJuridica.representante.fechaPoder,
                    poderAdjunto: value.personaJuridica.representante.poderAdjunto,
                    nombreCargo: value.personaJuridica.representante.nombreCargo,
                    nroAsambleaEstatuto: value.personaJuridica.representante.nroAsambleaEstatuto,
                    mail: value.personaJuridica.representante.mail,
                    celular: value.personaJuridica.representante.celular,
                    dni: value.personaJuridica.representante.dni,
                    direccion: {
                        tipoCalle: value.personaJuridica.representante.direccion.tipoCalle,
                        calle: value.personaJuridica.representante.direccion.calle,
                        numero: value.personaJuridica.representante.direccion.numero,
                        piso: value.personaJuridica.representante.direccion.piso,
                        departamento: value.personaJuridica.representante.direccion.departamento,
                        codigoPostal: value.personaJuridica.representante.direccion.codigoPostal,
                        localidad: value.personaJuridica.representante.direccion.localidad,
                    },
                } : null,
            } : null
        };
        return owner;
    }

    createOwner() {
        this.ownerFG.markAllAsTouched();
        if (!this.isGeneralSectionValid()) {
            this.stepper.selectedIndex = this.showBrokerSelectionStep ? 1 : 0;
            return;
        }
        if (!this.isRepresentativeSectionValid()) {
            this.stepper.selectedIndex = this.showBrokerSelectionStep ? 2 : 1;
            return;
        }
        if (!this.isAddressSectionValid()) {
            this.stepper.selectedIndex = this.showBrokerSelectionStep ? 3 : 2;
            return;
        }
        const owner: Owner = this.getResultingOwner();
        // ← AGREGAR ESTO TEMPORALMENTE
       console.log('Owner a enviar:', JSON.stringify(owner, null, 2));
        if (this.owner) {
            this.ownersService.editOwner(owner).subscribe(_ => {
                this.router.navigate(['propietarios']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al modificar propietario', error.error?.descripcion));
        } else {
            this.ownersService.createOwner(owner).subscribe(_ => {
                this.router.navigate(['propietarios']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al crear propietario', error.error?.descripcion));
        }
    }

    getBulkCreatorErrors = (row: any) => {
        const errors = [];
        if (row) {
            let validatorFormGroup: UntypedFormGroup;
            if (row.tipoPersona === 'FISICA')
                validatorFormGroup = this.validatorFormGroupPersonaFisica;
            else if (row.tipoPersona === 'JURIDICA')
                validatorFormGroup = this.validatorFormGroupPersonaJuridica;
            else
                return ['Tipo de persona inválido'];
            validatorFormGroup.setValue(row);
            Object.keys(validatorFormGroup.controls).map(controlName => {
                const control = validatorFormGroup.controls[controlName];
                if (!control.valid) {
                    Object.keys(control.errors).forEach(error => {
                        errors.push(`Campo: ${controlName}, error: ${error}.`);
                    });
                }
            });
        }
        return errors;
    }

    async getLocality(provinceName: string, municipalityName: string, localityName: string, index: number): Promise<Locality> {
        const provinces = await this.selectOptionsService.getProvinces().toPromise();
        const province = provinces.find(p => p.descripcion === provinceName || p.codigo === provinceName);
        if (province) {
            const municipalities = await this.selectOptionsService.getMunicipalities(province.codigo).toPromise();
            const municipality = municipalities.find(m => m.descripcion === municipalityName || m.codigo === municipalityName);
            if (municipality) {
                const localities = await this.selectOptionsService.getLocalities(province.codigo, municipality.codigo).toPromise();
                const locality = localities.find(l => l.descripcion === localityName || l.codigo === localityName);
                if (locality) {
                    return locality;
                } else {
                    throw new Error('Localidad ' + localityName + ' no encontrada en nuestra base de datos, fila: ' + (index + 1));
                }
            } else {
                throw new Error('Municipalidad ' + municipalityName + ' no encontrada en nuestra base de datos, fila: ' + (index + 1));
            }
        } else {
            throw new Error('Provincia ' + provinceName + ' no encontrada en nuestra base de datos, fila: ' + (index + 1));
        }
    }

    parsePhone(phoneString: string, index: number) {
        try {
            return this.utilsService.parsePhone(phoneString);
        } catch {
            throw new Error(`Error al parsear teléfono en la linea ${index + 1}, un ejemplo de teléfono correcto es: +54-911-22323223.`);
        }
    }

    bulkCreatorSubmit = async (values: any[]) => {
        const owners = await Promise.all(values.map(async (row, index) => {
            const owner: Owner = {
                codigo: row.codigo,
                tipoPersona: row.tipoPersona,
                email: row.email,
            };
            const direccion: Address = {
                tipoCalle: row.tipoCalle,
                calle: row.calle,
                numero: row.numero,
                piso: row.piso,
                departamento: row.departamento,
                codigoPostal: row.codigoPostal,
                localidad: await this.getLocality(row.provincia, row.municipio, row.localidad, index)
            };
            const celular = this.parsePhone(row.celular, index);
            const rubro = this.legalPersonForm.headings.find(heading => heading.descripcion === row.rubro);
            const situacionIVA = this.legalPersonForm.ivaSituations.find(is => is.descripcion === row.situacionIVA);
            if (owner.tipoPersona === 'FISICA') {
                owner.personaFisica = {
                    dni: row.dni,
                    sexo: row.sexo,
                    fechaNacimiento: moment.utc(row.fechaNacimiento, 'DD/MM/YYYY').toISOString(),
                    nombre: row.nombre,
                    apellido: row.apellido,
                    email: row.email,
                    celular,
                    direccion
                };
            } else if (owner.tipoPersona === 'JURIDICA') {
                owner.personaJuridica = {
                    cuit: row.cuit,
                    razonSocial: row.razonSocial,
                    tipoSociedad: row.tipoSociedad,
                    email: row.email,
                    rubro: { codigo: null, descripcion: row.rubro },
                    situacionIVA: { codigo: null, descripcion: row.situacionIVA },
                    celular,
                    direccion,
                };
            }
            return owner;
        }));
        return await this.ownersService.bulkLoad(owners).toPromise();
    }

    openSelectBrokerModal() {
        this.dialog.open(BrokerSelectorDialogComponent).afterClosed().subscribe({
            next: (broker: Broker | undefined) => {
                if (broker) {
                    this.broker = broker;
                    setTimeout(() => {
                        this.stepper?.next();
                    });
                }
            }
        });
    }
}
